// Web shim for @react-native-firebase/storage
// Uses firebase/compat which has the same chained API as @react-native-firebase.
import firebase from '../../config/firebase.web';

const storage = () => firebase.storage();

export default storage;
